var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import { formatLicensePlate, validateLicensePlate } from '@anwb/validations-license-plate';
import { FormFieldLicensePlateInput } from './styles/license-plate-input.styled';
class FormFieldLicensePlate extends Component {
    constructor() {
        super(...arguments);
        this.handlerTransformationVisual = (value = '') => new Promise((resolve) => {
            return resolve(formatLicensePlate(value));
        });
        this.handlerValidation = (value = '') => 
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        new Promise((resolve, reject) => {
            if (!validateLicensePlate(value)) {
                return reject('Het ingevoerde kenteken lijkt ongeldig.');
            }
            if (typeof this.props.additionalHandlerValidation === 'function') {
                return this.props.additionalHandlerValidation(value).then(resolve).catch(reject);
            }
            return resolve();
        });
    }
    render() {
        const _a = this.props, { size, reference = 'license-plate', name = 'license-plate', value, required, textInfo, tooltip, textValidationMessages, label, componentName = 'form-field-license-plate' } = _a, props = __rest(_a, ["size", "reference", "name", "value", "required", "textInfo", "tooltip", "textValidationMessages", "label", "componentName"]);
        return (React.createElement(FormFieldLicensePlateInput, Object.assign({}, props, { variant: "license-plate", className: "PONCHO-input-license-plate", componentName: componentName, type: "text", size: size, reference: reference, label: label, required: required, textInfo: textInfo, tooltip: tooltip, name: name, placeholder: "", value: value, maxlength: 9, textValidationMessages: textValidationMessages, handlerValidation: this.handlerValidation, handlerTransformationVisual: this.handlerTransformationVisual })));
    }
}
FormFieldLicensePlate.defaultProps = {
    size: 'm',
    value: '',
    required: true,
    textInfo: '',
    label: 'Kenteken',
    textValidationMessages: {
        valueMissing: 'Je hebt je kenteken nog niet ingevuld.',
    },
};
export default FormFieldLicensePlate;
//# sourceMappingURL=FormFieldLicensePlate.js.map